module.exports = {
      id: "icon-alert-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-alert",
      toString: function () {
        return this.url;
      }
    }